import { formatCompletionTime, stripHtml } from '../utils';

export default class LearningModule {
  constructor(module) {
    this.id = module.id;
    this.additionalInformationHtml = module.additionalInformationHtml;
    this.completionPageHtml = module.completionPageHtml;
    this.completionTime = module.completionTime;
    this.description = module.description;
    this.featuredAttachmentId = module.featuredAttachmentId;
    this.moduleSections = module.moduleSections;
    this.productAssociations = module.productAssociations;
    this.title = module.title;
    this.unlockedBy = module.unlockedBy;
  }

  get assetType() {
    return 'LearningModule';
  }

  get assetTitle() {
    let title = this.title || 'Learning Module';
    return stripHtml(title);
  }

  get route() {
    return {
      name: 'learningModules#start',
      params: {
        learningModuleId: this.id,
      },
    };
  }

  completedState(state) {
    return state && state.status === 'completed';
  }

  cardMetadata() {
    if (this.completionTime) {
      return formatCompletionTime(this.completionTime);
    }
  }

  difficultyLabel(store) {
    // if (this.difficultyLowerBound) {
    //   const allLevels = store.getters['difficultyLevels/all'];
    //   const level = allLevels.find(l => l.difficultyLevel == this.difficultyLowerBound);
    //   return level?.label;
    // }
    //
    // This is a placeholder until difficulty level exists on all asset types
    return false;
  }

  state(store) {
    return store.getters['learningModuleStates/get'][this.id];
  }
}
